var common = require('./common')

$(function() {
  if ( $('#product-switch-language') )
  {
    $('#product-switch-language').change(function() {
      var label = $('.product__data-title.data-french').text()
      if ( $(this).is(':checked') )
      {
        $('.data-french').addClass('hide')
        $('.data-english').removeClass('hide')
        $('.openaccess-langue').val('en');
        createCookie('last_product_language', 'en', 365)

        common.dataLayerPush({
          'event'      : 'GAEvent',
          'eventAction': 'Click',
          'eventLabel' : label,
          'eventValue' : 'en',
          'eventPage'  : window.location.href
        })
      }
      else
      {
        $('.data-french').removeClass('hide')
        $('.data-english').addClass('hide')
        $('.openaccess-langue').val('fr');
        createCookie('last_product_language', 'fr', 365)

        common.dataLayerPush({
          'event'      : 'GAEvent',
          'eventAction': 'Click',
          'eventLabel' : label,
          'eventValue' : 'fr',
          'eventPage'  : window.location.href
        })
      }
    })

    var cookie = readCookie('last_product_language')
    if ( cookie )
    {
      if ( cookie != 'fr' )
      {
        $('#product-switch-language').click()
      }
    }

    $('#openaccess-downloadform').submit(function(e){
      e.preventDefault();
      var form = $(this);
      $('body').find('#openaccess-spinner').removeClass('hide');
      var actionUrl = form.attr('action');
      
      $.ajax({
        type: "GET",
        url: actionUrl,
        data: form.serialize(), // serializes the form's elements.
        success: function(data)
        {
          //console.log(data);
          $('body').find('#openaccess_feedback').html('<span class="label label-success">'+data.message+'</span>'); // show response from the php script.
          $('body').find('#openaccess-spinner').addClass('hide');
          $('body').find('#openaccess-downloadform button:has(.openaccess-submit)').addClass('hide');
        },
        error: function(data){
          //console.log(data);
          $('body').find('#openaccess_feedback').html('<span class="label label-danger">Error</span>'); // show response from the php script.
          $('body').find('#openaccess-spinner').addClass('hide');
        }
      });
      });
  }
  
  function populatePriceToButtonAddSubscription() {
    
    $('#modal_abonnement_footer > div > div.col-sm-9 span').each(function(index) {
      
      if( $(this).css('display') == 'inline' && $(this).hasClass('data-french') == false && $(this).hasClass('data-english') == false) {
        console.log($(this).html());

        var visiblePrice= $(this).text();
        console.log(visiblePrice);
        if(visiblePrice) {
          $('#button_add_subscription').attr('data-price',visiblePrice);
        }
        
      }
    })
    
    
  }
  $('#subscription_modal_format_fr').on('change',function(){
    var v = $(this).val();
    $('#modal_abonnement_footer').removeClass('e').removeClass('ep').addClass(v);
    $('#button_add_subscription').attr('data-type',v);
    populatePriceToButtonAddSubscription();
    
  });
  $('#subscription_modal_format_en').on('change',function(){
    var v = $(this).val();
    $('#modal_abonnement_footer').removeClass('e').removeClass('ep').addClass(v);
    $('#button_add_subscription').attr('data-type',v);
    populatePriceToButtonAddSubscription();
  });
  $('#subscription_modal_zone').on('change',function(){
    var v = $(this).val();
    $('#modal_abonnement_footer').removeClass('fr').removeClass('eu').removeClass('noeu').addClass(v);
    $('#button_add_subscription').attr('data-delivery',v);
    populatePriceToButtonAddSubscription();
  });
  var userLogged = function()
  {
    if ( drupalSettings.user.uid == 0 )
    {
      return false
    }
    else
    {
      return true
    }
  }

  var userLogged = userLogged()
  $('body').on('click','.btn-add-subscription-to-cart',function(e){
    e.preventDefault();
    console.log('got u');
    if ( userLogged )
    {
      var $el = $(this)
      //var fields  = $('#form-add-product-' + $(this).data('pid') + '-' + $(this).data('type')).serializeArray();
      $('#confirmation_abo_cart').removeClass('hide');
      $('#abo_preadd_cart_resume').addClass('hide');
      var request = $.ajax({
        url: '/cart/add/product/' + $(this).data('pid') + '/' + Math.round($(this).data('price')) + '/' + $(this).data('type'),
        cache: false,
        success: function (data)
        {
          var v = parseInt($('#header-tools__count').text());
          v += 1 ;
          $('#header-tools__count').text(v);
          /*$('#abonnement_modal' ).fadeOut();
          $('.modal-backdrop').fadeOut();*/
          

        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
    else
    {
      $('#please-login-modal').css({
        'top': '50%',
        'margin-top': function() { return -$(this).outerHeight()/2 }
      })
      $('#please-login-modal').modal('show')
    }


  })
  $(document).ready(function(){
    populatePriceToButtonAddSubscription();
  });
  
})


// WEBPACK FOOTER //
// ./js/commerce-product.js